import { Route } from '@angular/router';

export const companyRoutes: Route[] = [
  /* { path: '', pathMatch: 'full', component: InsertYourComponentHere } */
];
